import { useMediaQuery } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Icon from '../../atoms/Icon/Icon';
import * as styles from './Accordion.module.css';

const Accordion = props => {
  const {
    title,
    type = 'caret',
    customStyle,
    children,
    defaultOpen = false,
    hideIcon,
    overrideSize = false
  } = props;

  const [isPc] = useMediaQuery('(min-width: 800px)', {
    ssr: true,
    fallback: false
  });
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    if (defaultOpen) setOpen(isPc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPc]);

  const combinedStyling = { ...styles, ...customStyle };
  const icon =
    type === 'caret' ? (
      <Icon symbol={'caret'}></Icon>
    ) : (
      <Icon symbol={`${open === true ? 'minus' : 'plus'}`}></Icon>
    );

  return (
    <div className={`${combinedStyling.accordionRoot} ${combinedStyling.accordionRootCustom}`}>
      <div
        className={`${combinedStyling.accordionHeader} ${combinedStyling.accordionHeaderRootCustom}`}
        role={'presentation'}
        onClick={isPc && !overrideSize ? undefined : () => setOpen(!open)}
      >
        <span className={`${combinedStyling.uppercase} ${combinedStyling.accordionTitleCustom} `}>
          {title}
        </span>
        <div
          className={`${combinedStyling.iconContainer} ${combinedStyling.iconContainerCustom} ${
            hideIcon ? 'hideIcon' : ''
          } ${open === true ? styles.rotate : ''}`}
        >
          {icon}
        </div>
      </div>
      <div
        className={`${styles.accordionContent}  ${
          open === true || (isPc && !overrideSize)
            ? `open ${styles.show} ${combinedStyling.show} `
            : styles.hide
        } ${combinedStyling.accordionContentCustom} `}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
